import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Div from "@jumbo/shared/Div";
import { alpha } from "@mui/material/styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axios_public } from "../../../axios";
import { Info } from "@mui/icons-material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Tooltip from "@mui/material/Tooltip";


const TenantPasswordReset = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading,setLoading] = useState(false);
    const [expired,setExpired] = useState(false)
    const initialState = {
        email: searchParams.get("email"),
        password: "",
        repassword: "",
        isAdmin: searchParams.get("isAdmin") === "true",
    };
    const [parameters, setParameters] = useState(initialState);
    const { email, password, repassword,isAdmin } = parameters;
    const [passPolicy, setPassPolicy] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepassword, setShowRepassword] = useState(false);

    const token = searchParams.get("token");

    useEffect(()=>{
        checkLinkExpiry();
    },[])

    const handleChange = e => {
        e.preventDefault();
        setParameters({ ...parameters, [e.target.id]: e.target.value });
    };

    const handleSubmit = e => {
        e.preventDefault();
        setLoading(true);
        const urlRoute = isAdmin? "/superAdmin/reset-password" : "/tenantAPI/user/reset-password";
        axios_public
            .post(urlRoute, parameters , {
                headers: {
                    "X-Expiry-Token": token
                }
            })
            .then(res => {
                setLoading(false);
                if(isAdmin){
                    navigate("/superadmin/login");
                }else{
                    navigate("/login");
                }
            })
            .catch(err => {
                setLoading(false);
            });
    };

    const checkLinkExpiry = () =>{
        const urlRoute = isAdmin ? '/superAdmin/checkLinkExpiry' : '/tenantAPI/user/checkResetPasswordLinkExpiry';
        axios_public
            .post(urlRoute, {email: searchParams.get("email")}, {
                headers : {
                    "X-Expiry-Token": searchParams.get("token")
                }
            })
            .then((res)=>{
                if (res.status !== 200) {
                    setExpired(true);
                }
            })
            .catch((err)=>{
                if(err.response?.status === 400){
                    setExpired(true);
                }
            })
    }

    return (
        expired ? 
        (<Div sx={{
            flex: 1,
            flexWrap: 'wrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: theme => theme.spacing(4),
        }}>
            <Typography align={"center"} component={"h2"} variant={"heading"} color={"red"} mb={3}>
                The link has expired, please resend the password-reset link
            </Typography>
        </Div>) : 
        <Div
            sx={{
                width: 720,
                maxWidth: "100%",
                margin: "auto",
                p: 4,
            }}
        >
            <Card
                sx={{
                    display: "flex",
                    minWidth: 0,
                    flexDirection: { xs: "column", md: "row" },
                    background : "#FFF"
                }}
            >
                <CardContent
                    sx={{
                        flex: "0 1 300px",
                        position: "relative",
                        background: "#010160",
                        backgroundSize: "cover",

                        "&::after": {
                            display: "inline-block",
                            position: "absolute",
                            content: `''`,
                            inset: 0,
                            backgroundColor: alpha("#010160", 0.65)
                        }
                    }}
                >
                    <Div
                        sx={{
                            display: "flex",
                            minWidth: 0,
                            flex: 1,
                            flexDirection: "column",
                            color: "common.white",
                            position: "relative",
                            zIndex: 1,
                            height: "100%"
                        }}
                    >
                        <Div sx={{ mb: 2 }}>
                            <Typography variant={"h3"} color={"white"} fontWeight={300} mb={3}>
                                Password Reset
                            </Typography>
                            <Typography variant={"body1"} mb={2}></Typography>
                        </Div>
                    </Div>
                </CardContent>
                <CardContent
                    sx={{
                        flex: 1,
                        p: 4,
                    }}
                >
                    <Div sx={{ display: "flex",justifyContent: "center", alignItems: "center",mt: "auto",mb: 4}}>
                        <img src={"/images/logo.png"} alt="" style={{maxWidth: "100%", objectFit: "contain"}}/>
                    </Div>

                    <Div sx={{ mt: 1, mb: 3 }}>
                        <TextField fullWidth id="email" label="Email" disabled value={searchParams.get("email")} onChange={handleChange} />
                    </Div>
                    <Div sx={{ mt: 1, mb: 2 }}>
                        <TextField
                            fullWidth id="password" label="Password" type={showPassword ? "text" : "password"}
                            value={password} onChange={handleChange}
                            InputProps={{ endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title={showPassword ? "Hide password" : "Show password"}>
                                        <IconButton type="button" edge="end" aria-label={showPassword ? "Hide password" : "Show password"}
                                            onMouseDown={event => event.preventDefault()} onClick={() => setShowPassword(value => !value)}>
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) }}
                        />
                    </Div>
                    <Div sx={{ mt: 1, mb: 2 }}>
                        <TextField
                            fullWidth id="repassword" label="Re-enter Password" type={showRepassword ? "text" : "password"}
                            value={repassword} onChange={handleChange}
                            InputProps={{ endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title={showRepassword ? "Hide password" : "Show password"}>
                                        <IconButton type="button" edge="end" aria-label={showRepassword ? "Hide password" : "Show password"}
                                            onMouseDown={event => event.preventDefault()} onClick={() => setShowRepassword(value => !value)}>
                                            {showRepassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) }}
                        />
                    </Div>

                    <Div sx={{ mt: 1, mb: 2, fontSize: 12 }}>
                        Password Guidelines <Info onClick={() => setPassPolicy(!passPolicy)} />
                    </Div>
                    {passPolicy && (
                        <div>
                            <ul style={{ fontSize: 12 }}>
                                <li>At least 8 character long</li>
                                <li>One upper case letter (A-Z)</li>
                                <li>One lower case letter (a-z)</li>
                                <li>Contains at least One numeric digit (0-9)</li>
                                <li> Contains at least one special character, i.e. ( ! @ # ? )</li>
                                <li>Should not contain username in password</li>
                            </ul>
                        </div>
                    )}
                    <Button type="submit" variant="contained" sx={{ mb: 2 }} onClick={handleSubmit} disabled={loading}>
                    {loading  ? <CircularProgress size={25} sx={{ color: "blue" }} /> : <span>Update Password</span>} 
                    </Button>
                </CardContent>
            </Card>
        </Div>
    );
};

export default TenantPasswordReset;